
import { defineComponent } from "vue";
import { ConnectCta, ConnectProviderList } from "@/modules/connect/components";
import { useRouter } from "vue-router";
import { notify } from "notiwind";
import { IProvider } from "@whitelabel-solutions/wallet-connector";
import { useWallet } from "@/common/composables/useWallet";

export default defineComponent({
  components: { ConnectProviderList, ConnectCta },
  setup() {
    const wallet = useWallet();
    const router = useRouter();

    const login = async (instance: IProvider) => {
      try {
        await wallet.connect(instance);
        await router.back();
      } catch (e) {
        notify({
          group: "app",
          title: "Error",
          text: "Error connecting wallet",
        });
        console.error(e);
      }
    };

    return { login, wallet };
  },
});
